var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFurniture = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1549_41371)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.129631 4.04867C0.0250817 2.32361 1.39591 0.867188 3.12413 0.867188H32.1168C33.7031 0.867188 35.0153 2.10224 35.1113 3.6857L36.2155 21.9055L34.2192 22.0265L33.1149 3.8067C33.083 3.27887 32.6456 2.86719 32.1168 2.86719H3.12413C2.54806 2.86719 2.09111 3.35266 2.12596 3.92768L3.99742 34.8067L2.00108 34.9277L0.129631 4.04867Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12963 4.04868C4.02508 2.32362 5.39591 0.867188 7.12413 0.867188H8.99925V2.86719H7.12413C6.54806 2.86719 6.09111 3.35267 6.12596 3.92769L7.1526 20.8672H13.9772V22.8672H7.1526C6.09502 22.8672 5.22024 22.0438 5.15626 20.9882L4.12963 4.04868Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 22.8672C12.001 21.7626 12.8964 20.8672 14.001 20.8672H16.001C17.1056 20.8672 18.001 21.7626 18.001 22.8672V34.3672H16.001V22.8672H14.001V52.8672H12.001V22.8672Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6729 23.0057C31.5927 21.8494 32.509 20.8672 33.6681 20.8672H44.9989V22.8672H33.6681L34.4965 34.7979L32.5013 34.9365L31.6729 23.0057Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.999 22.8672C47.999 21.7626 47.1036 20.8672 45.999 20.8672H43.999C42.8944 20.8672 41.999 21.7626 41.999 22.8672V34.3672H43.999V22.8672H45.999V52.8672H47.999V22.8672Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 35.8672H4V43.8672H46V35.8672ZM2 33.8672V45.8672H48V33.8672H2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5879 52.8672H38.622L40.1047 44.8672H38.0707L36.5879 52.8672Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.521484 52.8672H2.55555L4.03832 44.8672H2.00426L0.521484 52.8672Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1549_41371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0 0.867188)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFurniture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/furniture.0a7914cf95fd4b0747a2c04fdda5e94d.svg";